import { AxiosInstance } from "axios";

export default class PublicPersonRequestAdminController {
  private url: string;
  private api: AxiosInstance;

  constructor(url: string, api: AxiosInstance) {
    this.url = url + "/public_person/admin";
    this.api = api;
  }

  public async getAllPublicPersonRequest(size: number, page: number) {
    const response = await this.api.get(`${this.url}/all`, {
      params: {
        size: size,
        page: page,
      },
    });

    return response;
  }

  public async getAllActivePublicPersonRequest(size: number, page: number) {
    const response = await this.api.get(`${this.url}`, {
      params: {
        size: size,
        page: page,
      },
    });

    return response;
  }

  public async approve(requestId: string) {
    const response = await this.api.post(`${this.url}/approve`, "", {
      params: {
        requestId: requestId,
      },
    });

    return response;
  }

  public async reject(requestId: string, message: string) {
    const response = await this.api.post(`${this.url}/reject`, message, {
      params: {
        requestId: requestId,
      },
    });

    return response;
  }
}
